import {
  HomeBanner,
  HomeContainer,
  HomeDivider,
  HomeFallbackCategories,
  HomeGenericCategories,
  HomeFilterableCategories,
  HomeFooter,
  HomeReorderRail,
  HomeOrderCard,
  HomeOrderBanner,
  HomeLoyaltyCard,
  HomePostOrderContent,
  HomeOrderCanceledBanner,
  HomeRateOrderCard,
} from './components';

export const Home = {
  Container: HomeContainer,
  Banner: HomeBanner,
  OrderBanner: HomeOrderBanner,
  OrderCanceledBanner: HomeOrderCanceledBanner,
  PostOrderContent: HomePostOrderContent,
  FallbackCategories: HomeFallbackCategories,
  GenericCategories: HomeGenericCategories,
  FilterableCategories: HomeFilterableCategories,
  ReorderRail: HomeReorderRail,
  LoyaltyCard: HomeLoyaltyCard,
  OrderCard: HomeOrderCard,
  RateOrderCard: HomeRateOrderCard,
  Footer: HomeFooter,
  Divider: HomeDivider,
};
